var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from 'react';
import { useDataProvider, useNotify, } from 'react-admin';
import { useQueryClient } from 'react-query';
import { UsingRegexp } from './constants';
export var useUpdateManyToManyReferences = function () {
    var dataProvider = useDataProvider();
    var queryClient = useQueryClient();
    var notify = useNotify();
    return useCallback(function (_a, _b) {
        var newReferences = _a.newReferences, resourceId = _a.resourceId, through = _a.through, using = _a.using, perPage = _a.perPage;
        var _c = _b === void 0 ? {} : _b, _d = _c.mutationOptions, mutationOptions = _d === void 0 ? {} : _d, transform = _c.transform;
        return __awaiter(void 0, void 0, void 0, function () {
            var onError, _e, sourceField, targetField, throughManyReferences, error_1, errorMessage, previousReferences, _f, addedReferences, removedReferences, ids_1;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        onError = (mutationOptions || {}).onError;
                        _e = using.match(UsingRegexp), sourceField = _e[1], targetField = _e[2];
                        _g.label = 1;
                    case 1:
                        _g.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, dataProvider.getManyReference(through, {
                                target: sourceField,
                                id: resourceId,
                                filter: {},
                                sort: { field: 'id', order: 'ASC' },
                                pagination: { page: 1, perPage: perPage },
                            })];
                    case 2:
                        // Fetch the current associative records
                        throughManyReferences = _g.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _g.sent();
                        if (onError) {
                            return [2 /*return*/, onError(error_1, 'fetchLinkRecords')];
                        }
                        errorMessage = typeof error_1 === 'string'
                            ? error_1
                            : // NOTE: We might have to introduce a new message instead of http_error
                                error_1.message || 'ra.notification.http_error';
                        notify(errorMessage, { type: 'warning' });
                        return [2 /*return*/];
                    case 4:
                        previousReferences = throughManyReferences.data.map(function (throughManyReference) { return throughManyReference[targetField]; });
                        _f = computeReferencesDiff(previousReferences, newReferences), addedReferences = _f.addedReferences, removedReferences = _f.removedReferences;
                        if (!(removedReferences.length > 0)) return [3 /*break*/, 6];
                        ids_1 = throughManyReferences.data
                            .filter(function (throughManyReference) {
                            return removedReferences.includes(throughManyReference[targetField]);
                        })
                            .map(function (throughManyReference) { return throughManyReference.id; });
                        // We use the dataProvider directly here to avoid react-query cache updates
                        // as it would make the input shows invalid data until everything is done
                        // for the references update
                        return [4 /*yield*/, dataProvider
                                .deleteMany(through, {
                                ids: ids_1,
                            })
                                .catch(function (error) {
                                if (onError) {
                                    return onError(error, 'deleteLinkRecords', ids_1);
                                }
                            })];
                    case 5:
                        // We use the dataProvider directly here to avoid react-query cache updates
                        // as it would make the input shows invalid data until everything is done
                        // for the references update
                        _g.sent();
                        _g.label = 6;
                    case 6:
                        if (!(addedReferences.length > 0)) return [3 /*break*/, 8];
                        return [4 /*yield*/, Promise.all(addedReferences.map(function (referenceId) {
                                var _a;
                                var data = (_a = {},
                                    _a[sourceField] = resourceId,
                                    _a[targetField] = referenceId,
                                    _a);
                                var finalData = transform
                                    ? transform(data)
                                    : data;
                                // We use the dataProvider directly here to avoid react-query cache updates
                                // as it would make the input shows invalid data until everything is done
                                // for the references update
                                return dataProvider
                                    .create(through, {
                                    data: finalData,
                                })
                                    .catch(function (error) {
                                    if (onError) {
                                        return onError(error, 'createLinkRecord', data);
                                    }
                                });
                            }))];
                    case 7:
                        _g.sent();
                        _g.label = 8;
                    case 8:
                        if (!(addedReferences.length > 0 ||
                            removedReferences.length > 0)) return [3 /*break*/, 10];
                        // If we updated the references, we need to invalidate the cache for its queries
                        return [4 /*yield*/, queryClient.invalidateQueries([
                                through,
                                'getManyReference',
                            ])];
                    case 9:
                        // If we updated the references, we need to invalidate the cache for its queries
                        _g.sent();
                        _g.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    }, [dataProvider, notify, queryClient]);
};
export var computeReferencesDiff = function (previousReferences, newReferences) {
    var removedReferences = previousReferences.filter(function (previousReference) { return !newReferences.includes(previousReference); });
    var addedReferences = newReferences.filter(function (referenceId) { return !previousReferences.includes(referenceId); });
    return {
        addedReferences: addedReferences,
        removedReferences: removedReferences,
    };
};
